import { render, staticRenderFns } from "./suspensionList.vue?vue&type=template&id=eb9064d0&scoped=true&"
import script from "./suspensionList.vue?vue&type=script&lang=js&"
export * from "./suspensionList.vue?vue&type=script&lang=js&"
import style0 from "./suspensionList.vue?vue&type=style&index=0&id=eb9064d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb9064d0",
  null
  
)

export default component.exports